//// IMAGE CHANGING

export const subclass_id_to_class_img = {
    "sunbreaker_subclass": "/static/img/sunbreaker.jpg",
    "striker_subclass": "/static/img/striker.jpg",
    "sentinel_subclass": "/static/img/sentinel.jpg",
    "behemoth_subclass": "/static/img/behemoth.jpg",
    "berserker_subclass": "/static/img/berserker.jpg",
    "prismatic_titan_subclass": "/static/img/prismatic_titan.jpg",
    "dawnblade_subclass": "/static/img/dawnblade.jpg",
    "stormcaller_subclass": "/static/img/stormcaller.jpg",
    "voidwalker_subclass": "/static/img/voidwalker.jpg",
    "shadebinder_subclass": "/static/img/shadebinder.jpg",
    "broodweaver_subclass": "/static/img/broodweaver.jpg",
    "prismatic_warlock_subclass": "/static/img/prismatic_warlock.jpg",
    "gunslinger_subclass": "/static/img/gunslinger.jpg",
    "arcstrider_subclass": "/static/img/arcstrider.jpg",
    "nightstalker_subclass": "/static/img/nightstalker.jpg",
    "revenant_subclass": "/static/img/revenant.jpg",
    "threadrunner_subclass": "/static/img/threadrunner.jpg",
    "prismatic_hunter_subclass": "/static/img/prismatic_hunter.jpg",
};

export function update_background(subclass_id)
{
    let preload_background = new Image();
    preload_background.src = subclass_id_to_class_img[subclass_id];

    document.getElementById('body_bg').style.backgroundImage = "url(" + preload_background.src + ")";
}